import pathOr from 'ramda/src/pathOr';
import { stateGo } from 'redux-ui-router';
import { BusinessUnitSelectors } from 'invision-core';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import i18n from 'invision-core/src/components/i18n/i18n';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { createOverrideSession } from 'invision-core/src/reducers/actions/user/user.actions';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { hasAccess } from 'invision-core/src/components/security/permission.service';
import { MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { MODULES } from 'invision-core/src/constants/module.constants';
import { IsOverrideActiveSelector, SessionIdSelector, UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { retrieveDiscountsMetadata, retrieveDiscretionaryDiscountsMetadata } from 'invision-core/src/components/metadata/discounts/discounts.actions';
import CustomerCareLocaleKeys from '../../locales/keys';
import { CUSTOMERCARE_PAGE_APP_ID, LoadNavigatorItems, NavigatorFlyoutCaption, RECENT_CUSTOMERS_NAV_ITEM_ID, SALES_PIPELINE_NAV_ITEM_ID, SEARCH_NAV_ITEM_ID, customerCareRoute } from './customercare.page.constants';
import { IsCustomerWrapUpRequiredSelector, IsSearchPanelVisibleSelector } from '../../reducers/selectors/search.selectors';
import { CUSTOMER_CATEGORY } from '../createCustomerPopup/create.customer.popup.constants';
import { CreateEditCustomerSelector, CurrentCustomerIdSelector, IsWrappingCustomerSelector } from '../../reducers/selectors/customer.selectors';
import { hideSearchPanel, showSearchPanel } from '../../reducers/actions/search.actions';
import { NOTIFICATION_TIME_LENGTH, ROOT_CARE_MODULE_ROUTE } from '../../customercare.constants';
import { ContentActivityBetaUIFeatureToggleSelector, CouponsBetaUIFeatureToggleSelector, CustomerActionsTemplateSelector, DevicesBetaUIFeatureToggleSelector, NonTelcoUsageServiceFeatureToggleSelector, InvisionCareModuleNameCustomizationUIFeatureToggleSelector, SalesPipelineFeatureToggleSelector, BillingLedgerBetaUIFeatureToggleSelector, SubscriptionChangeOrderFlowUIFeatureToggleSelector, SubscriptionsBetaUIFeatureToggleSelector, TotalsBetaUIFeatureToggleSelector, TransactionsBetaUIFeatureToggleSelector, ReactHouseholdPageFeatureToggleSelector, ReactCustomPageFeatureToggleSelector } from '../../reducers/selectors/customer.actions.template.selectors';
import { CREATE_COMMERCIAL_CUSTOMER_GLOBAL_ACTION, CREATE_CUSTOMER_GLOBAL_ACTION, CREATE_RESIDENTIAL_CUSTOMER_GLOBAL_ACTION, GUEST_CHECKOUT_GLOBAL_ACTION, NEW_CONNECT_GLOBAL_ACTION } from '../customerActionsTemplate/global.actions';
import { IsPanelVisibleSelector } from '../../reducers/selectors/recent.customers.selectors';
import { hideRecentCustomersPanel, showRecentCustomersPanel } from '../../reducers/actions/recent.customers.actions';
import { loadSubscriberRequirements } from '../../reducers/helpers/subscriber.requirements.actions.helper';
import { INITIAL_STATE as CREATE_CUSTOMER_INITIAL_STATE } from '../../reducers/create.customer.reducer';
import { STATE_OR_NAME as NEW_CONNECT_STATE, GUEST_CHECKOUT } from '../../reducers/constants/new.connect.wizard.constants';
import PanelAutoClose from 'invision-core/src/utilities/panel.auto.close.handler';
import { customerWrapUp } from '../../reducers/actions/customer.actions';
import { OVERRIDE_OFFER_QUALIFICATION_ENFORCEMENT } from '../../security.attributes';
import { getReactRoutes } from './../../reactRoutes';
import { setupReactRoutes, redirectToReact } from 'invision-core/src/components/application/setupReactRoutes';
export function CustomerCarePageController($ngRedux, $timeout, $scope, $rootScope, $state, uiNotificationService, unsavedChangesPrompt) {
  var _this = this;
  var disconnectRedux;
  this.showCustomerWrapUp = false;
  var mapStateToTarget = function mapStateToTarget(store) {
    return {
      createCustomer: CreateEditCustomerSelector(store),
      currentCustomerId: CurrentCustomerIdSelector(store),
      customerActionsTemplate: CustomerActionsTemplateSelector(store),
      featureTogglesLoaded: MetadataCodeLoadedSelector(CODES.FeatureToggleConfig, store),
      isAccountingMethodLoaded: MetadataCodeLoadedSelector(CODES.Accounting, store),
      isBusinessUnitTemplateLoaded: MetadataCodeLoadedSelector(CODES.BusinessUnitTemplate, store),
      isConvergentBillerBehaviorConfigLoaded: MetadataCodeLoadedSelector(CODES.ConvergentBillerBehaviorConfig, store),
      isCustomerRequirementsLoaded: MetadataCodeLoadedSelector(CODES.SubscriberRequirements)(store),
      isCustomerWrapUpLoaded: MetadataCodeLoadedSelector(CODES.CustomerWrapUp, store),
      isCustomerWrapupRequired: IsCustomerWrapUpRequiredSelector(store),
      isDbss: BusinessUnitSelectors.IsDbss(store),
      isSalesPipelineEnabled: SalesPipelineFeatureToggleSelector(store),
      isBillingLedgerBetaEnabled: BillingLedgerBetaUIFeatureToggleSelector(store),
      isContentActivityBetaEnabled: ContentActivityBetaUIFeatureToggleSelector(store),
      isCouponsBetaEnabled: CouponsBetaUIFeatureToggleSelector(store),
      isDevicesBetaEnabled: DevicesBetaUIFeatureToggleSelector(store),
      isSubscriptionChangeOrderFlowEnabled: SubscriptionChangeOrderFlowUIFeatureToggleSelector(store),
      isSubscriptionsBetaEnabled: SubscriptionsBetaUIFeatureToggleSelector(store),
      isTotalsBetaEnabled: TotalsBetaUIFeatureToggleSelector(store),
      isTransactionsBetaEnabled: TransactionsBetaUIFeatureToggleSelector(store),
      isFeatureConfigurationLoaded: MetadataCodeLoadedSelector(CODES.FeatureConfiguration)(store),
      isInvisionCareNameCustomizationEnabled: InvisionCareModuleNameCustomizationUIFeatureToggleSelector(store),
      isNonTelcoUsageServicePageEnabled: NonTelcoUsageServiceFeatureToggleSelector(store),
      isOverrideActive: IsOverrideActiveSelector(store),
      isReactHouseholdPageEnabled: ReactHouseholdPageFeatureToggleSelector(store),
      isReactCustomPageEnabled: ReactCustomPageFeatureToggleSelector(store),
      isRecentCustomersVisible: IsPanelVisibleSelector(store),
      isSearchPanelVisible: IsSearchPanelVisibleSelector(store),
      isSubscriberCategoryDefaultSubscriberTypeLoaded: MetadataCodeLoadedSelector(CODES.SubscriberCategoryDefaultSubscriberType)(store),
      isSubscriberSearchLoaded: MetadataCodeLoadedSelector(CODES.CustomerWrapUp, store),
      isSubscriberTypeLoaded: MetadataCodeLoadedSelector(CODES.SubscriberType)(store),
      isWrappingCustomer: IsWrappingCustomerSelector(store),
      router: store.router,
      sessionId: SessionIdSelector(store),
      userSecurityAttributes: UserSecurityAttributesSelector(store)
    };
  };
  var controllerActions = {
    createOverrideSession: createOverrideSession,
    customerWrapUp: customerWrapUp,
    fetchCodeTypes: fetchCodeTypes,
    hideRecentCustomersPanel: hideRecentCustomersPanel,
    hideSearchPanel: hideSearchPanel,
    loadSubscriberRequirements: loadSubscriberRequirements,
    retrieveDiscountsMetadata: retrieveDiscountsMetadata,
    retrieveDiscretionaryDiscountsMetadata: retrieveDiscretionaryDiscountsMetadata,
    stateGo: stateGo,
    showRecentCustomersPanel: showRecentCustomersPanel,
    showSearchPanel: showSearchPanel
  };
  var BLANK_CUSTOMER = CREATE_CUSTOMER_INITIAL_STATE;
  var unsavedChangesPromptPopupApi = null;
  var unsavedChangesPromptConfirmCallback = null;
  this.$onInit = function () {
    // most browsers won't actually display this message, a violation of the
    // spec, in the name of protecting the unsuspecting users ("security"),
    // but we set it anyway, as a few do
    unsavedChangesPrompt.setMessage(i18n.translate(CustomerCareLocaleKeys.UNSAVED_CHANGES_PROMPT.MESSAGE));
    unsavedChangesPrompt.setInterceptor(function (confirm) {
      unsavedChangesPromptConfirmCallback = confirm;
      unsavedChangesPromptPopupApi.open();
    });
    disconnectRedux = $ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
      _this.state = state;
      _this.actions = actions;
    });
    _this.customerCareLocaleKeys = CustomerCareLocaleKeys;
    _this.coreLocaleKeys = CoreLocaleKeys;
    _this.onOverride = _this.onOverride.bind(_this);
    _this.onCreateCustomerModalError = _this.onCreateCustomerModalError.bind(_this);

    // Initialize nav items, will be updated when feature toggles load
    _this.navItems = LoadNavigatorItems();
    _this.navFlyoutCaption = NavigatorFlyoutCaption();
    var promiseList = [];

    // hook the popupApi
    _this.unsavedChangesPromptPopupConfig = {
      onRegisterApi: function onRegisterApi(_ref) {
        var api = _ref.api;
        unsavedChangesPromptPopupApi = api;
      }
    };
    _this.showWelcomePage = function () {
      return _this.state.router.currentState.name === customerCareRoute;
    };
    _this.customerWrapUpPopup = {
      onRegisterApi: function onRegisterApi(_ref2) {
        var api = _ref2.api;
        _this.customerWrapUpPopupApi = api;
      }
    };
    _this.editCustomer = BLANK_CUSTOMER.asMutable({
      deep: true
    });
    if (!_this.state.isCustomerRequirementsLoaded) {
      _this.actions.loadSubscriberRequirements();
    }
    if (!_this.state.isConvergentBillerBehaviorConfigLoaded) {
      _this.actions.fetchCodeTypes(CODES.ConvergentBillerBehaviorConfig);
    }
    if (!_this.state.isSubscriberSearchLoaded) {
      _this.actions.fetchCodeTypes(CODES.SubscriberSearchConfig);
    }
    if (!_this.state.isSubscriberTypeLoaded) {
      _this.actions.fetchCodeTypes(CODES.SubscriberType);
    }
    if (!_this.state.isBusinessUnitTemplateLoaded) {
      promiseList.push(_this.actions.fetchCodeTypes(CODES.BusinessUnitTemplate));
    }
    if (!_this.state.featureTogglesLoaded) {
      promiseList.push(_this.actions.fetchCodeTypes(CODES.FeatureToggleConfig));
    }
    Promise.all(promiseList).then(function () {
      // Update navigation items with feature toggle state
      _this.navItems = LoadNavigatorItems(_this.state.isSalesPipelineEnabled);
      if ($state.current && $state.current.name === 'index.customercare') {
        redirectToReact($state, {
          // this is not a valid react route, but it will redirect to the home page
          // redirectToReact does not allow / as a valid route to redirect to
          url: '/home'
        }, undefined, ROOT_CARE_MODULE_ROUTE);
      }
      setupReactRoutes($rootScope, $state, getReactRoutes({
        isNonTelcoUsageServicePageEnabled: _this.state.isNonTelcoUsageServicePageEnabled,
        isBillingLedgerBetaEnabled: _this.state.isBillingLedgerBetaEnabled,
        isContentActivityBetaEnabled: _this.state.isContentActivityBetaEnabled,
        isCouponsBetaEnabled: _this.state.isCouponsBetaEnabled,
        isDevicesBetaEnabled: _this.state.isDevicesBetaEnabled,
        isSubscriptionChangeOrderFlowEnabled: _this.state.isSubscriptionChangeOrderFlowEnabled,
        isSubscriptionsBetaEnabled: _this.state.isSubscriptionsBetaEnabled,
        isTotalsBetaEnabled: _this.state.isTotalsBetaEnabled,
        isTransactionsBetaEnabled: _this.state.isTransactionsBetaEnabled,
        isDbss: _this.state.isDbss,
        isReactHouseholdPageEnabled: _this.state.isReactHouseholdPageEnabled,
        isReactCustomPageEnabled: _this.state.isReactCustomPageEnabled
      }));
    });
    _this.actions.retrieveDiscountsMetadata();
    _this.actions.retrieveDiscretionaryDiscountsMetadata();
    if (!_this.state.isFeatureConfigurationLoaded) {
      _this.actions.fetchCodeTypes(CODES.FeatureConfiguration);
    }
    if (!_this.state.isAccountingMethodLoaded) {
      _this.actions.fetchCodeTypes(CODES.Accounting);
    }
    PanelAutoClose.start();
  };
  this.$onDestroy = function () {
    disconnectRedux();
    PanelAutoClose.stop();
  };
  this.openCreateCustomerModal = function () {
    _this.showCustomerPopup = true;
  };
  this.closeCreateCustomerPopup = function () {
    _this.showCustomerPopup = false;
  };
  this.onCreateCustomerModalError = function (error) {
    uiNotificationService.transientError(error);
  };
  this.handleToggleNavigatorCollapsedSelected = function () {
    _this.actions.toggleCollapsedSelected();
  };
  this.itemSelected = function (navItem) {
    _this.clearActiveFlagsOnNavItems();
    if (navItem.id === SEARCH_NAV_ITEM_ID) {
      if (_this.bypassCustomerWrapup()) {
        if (_this.state.isSearchPanelVisible) {
          _this.actions.hideSearchPanel();
        } else {
          _this.actions.showSearchPanel();
        }
      }
      navItem.isActive = _this.state.isSearchPanelVisible;
    } else if (navItem.id === RECENT_CUSTOMERS_NAV_ITEM_ID) {
      if (_this.bypassCustomerWrapup()) {
        if (_this.state.isRecentCustomersVisible) {
          _this.actions.hideRecentCustomersPanel();
        } else {
          _this.actions.showRecentCustomersPanel();
        }
        navItem.isActive = _this.state.isRecentCustomersVisible;
      }
    } else if (navItem.id === SALES_PIPELINE_NAV_ITEM_ID) {
      if (_this.bypassCustomerWrapup()) {
        redirectToReact($state, {
          url: '/sales-pipeline'
        }, undefined, ROOT_CARE_MODULE_ROUTE);
      }
    }
  };
  this.clearActiveFlagsOnNavItems = function () {
    _this.navItems.forEach(function (navItem) {
      navItem.isActive = false;
    });
  };
  this.flyoutItemSelected = function (_ref3) {
    var id = _ref3.id;
    if (_this.bypassCustomerWrapup()) {
      switch (id) {
        case CREATE_COMMERCIAL_CUSTOMER_GLOBAL_ACTION.id:
          {
            _this.isResidential = false;
            _this.isCreateCustomer = false;
            _this.showCustomerPopup = true;
            break;
          }
        case CREATE_CUSTOMER_GLOBAL_ACTION.id:
          {
            _this.isResidential = false;
            _this.isCreateCustomer = true;
            _this.showCustomerPopup = true;
            break;
          }
        case CREATE_RESIDENTIAL_CUSTOMER_GLOBAL_ACTION.id:
          {
            _this.isResidential = true;
            _this.isCreateCustomer = false;
            _this.showCustomerPopup = true;
            break;
          }
        case GUEST_CHECKOUT_GLOBAL_ACTION.id:
          {
            _this.actions.stateGo(GUEST_CHECKOUT, {}, {
              location: true,
              notify: true,
              reload: true
            });
            break;
          }
        case NEW_CONNECT_GLOBAL_ACTION.id:
          {
            _this.actions.stateGo(NEW_CONNECT_STATE, {}, {
              location: true,
              notify: true,
              reload: true
            });
            break;
          }
        default:
          break;
      }
    }
  };
  this.appId = CUSTOMERCARE_PAGE_APP_ID;
  this.handleResultUnsavedChangesPromptPopup = function (confirmed) {
    confirmed && unsavedChangesPromptConfirmCallback();
    unsavedChangesPromptConfirmCallback = null;
    unsavedChangesPromptPopupApi.close();
  };
  this.handleCloseUnsavedChangesPromptPopup = function () {
    unsavedChangesPromptPopupApi.close();
  };
  this.openCustomerWrapUpPopup = function () {
    _this.showCustomerWrapUp = true;
    $timeout(_this.customerWrapUpPopupApi.open);
  };
  this.closeCustomerWrapupModal = function () {
    _this.showCustomerWrapUp = false;
    _this.customerWrapUpPopupApi.close();
  };
  this.onCustomerWrapUp = function () {
    _this.isWrapupValid && _this.actions.customerWrapUp({
      customerId: _this.state.currentCustomerId,
      reasonId: _this.wrapupReason,
      comments: _this.wrapupComments
    }).then(function () {
      _this.closeCustomerWrapupModal();
      _this.actions.stateGo(ROOT_CARE_MODULE_ROUTE);
    }).catch(function (error) {
      uiNotificationService.transientError(error.translatedMessage);
    });
  };
  this.bypassCustomerWrapup = function () {
    return _this.state.isCustomerWrapupRequired && !!_this.state.currentCustomerId ? _this.openCustomerWrapUpPopup() : true;
  };
  this.hasOverrideAccess = function () {
    return _this.state && _this.state.userSecurityAttributes ? hasAccess(_this.state.userSecurityAttributes, OVERRIDE_OFFER_QUALIFICATION_ENFORCEMENT) : undefined;
  };
  this.onOverride = function () {
    _this.actions.createOverrideSession(_this.state.sessionId, !_this.state.isOverrideActive, MODULES.CUSTOMER_CARE);
  };
  this.onWrapupUpdate = function (formModel) {
    var wrapupReasonCode = pathOr(undefined, ['reason', 'Value'], formModel);
    _this.isWrapupValid = !!wrapupReasonCode;
    _this.wrapupReason = wrapupReasonCode;
    _this.wrapupComments = formModel.comments;
  };
}